import styled from 'styled-components';
import TableContainer from '@material-ui/core/TableContainer';
import TableCell from '@material-ui/core/TableCell';

const getSpacing = level => {
  return level * 8;
};

export const RldLibrarySection = styled.section`
  width: calc(100% - 10px);
  padding: ${getSpacing(4)}px ${getSpacing(3)}px;
`;

export const RldLibraryContainer = styled.div`
  display: flex;
  text-align: center;
  align-items: center;
  flex-direction: column;
`;

export const RldLibraryRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-grow: 0;
  width: 100%;
`;

export const RldLibraryHeading = styled.h2`
  color: #30435d;
`;

export const RldLibraryNewRequestLink = styled.a`
  margin: auto 0;
  font-weight: 700;
  color: #4D0F28;
  &:hover{
    color: #4D0F28;
  }
}
`;

export const RldLibraryNewRequestLinkWrapper = styled.div`
  display: flex;
  margin: auto 0;
}
`;

export const RldLibraryLinkWrapper = styled(RldLibraryNewRequestLinkWrapper)`
  justify-content: end;
}
`;

export const RldLibraryDataGrid = styled.div`
  width: 100%;
  height: 500px;
  overflow-y: scroll;
`;

export const RldGridHeadCell = styled(TableCell)`
  &.MuiTableCell-head {
    background-color: RGB(71, 100, 138);
    color: white;
    font-size: 12px;
    font-weight: bold;
    border-left: 1px solid #989898;
  }
`;

export const RldGridHeadFirstCell = styled(RldGridHeadCell)`
  &.MuiTableCell-head {
    border-top-left-radius: 8px;
    border-left: none;
  }
`;

export const RldGridHeadLastCell = styled(RldGridHeadCell)`
  &.MuiTableCell-head {
    border-top-right-radius: 8px;
  }
`;

export const RldGridCell = styled(TableCell)`
  &.MuiTableCell-root {
    padding-top: 10px;
    padding-bottom: 10px;
    font-size: 12px;
    color: #30435d;
    line-height: 1.4;
    border-left: 1px solid #989898;
    word-break: break-word;
  }
`;

export const RldGridFirstCell = styled(RldGridCell)`
  &.MuiTableCell-root {
    border-left: none;
  }
`;

export const RldGridTableContainer = styled(TableContainer)`
  &.MuiTableContainer-root {
    border: 1px solid RGB(14, 18, 42);
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }
`;

